// company redux actions
import {setGeneralCompanyData as setGeneralCompanyDataAction} from '../../../company/redux/reducer.redux.company';

// corporateHierarchy api
import loadParentCompanyApi from '../../../corporateHierarchy/api/loadParentCompany.api.corporateHierarchy';

// data services
import loadAndAttachAsyncJsonToObjectService from '../../../data/services/loadAndAttachAsyncJsonToObject.service.data';

// financial api
import loadPublicFinancialsApi from '../../../financial/api/loadPublicFinancials.api.financial';
import loadPrivateFinancialsApi from '../../../financial/api/loadPrivateFinancials.api.financial';

// financial components
import CustomFinancialsLayout from '../../../financial/components/CustomFinancialsLayout/CustomFinancialsLayout';
import FinancialsLayout from '../../../financial/components/FinancialsLayout/FinancialsLayout';
import FinancialsLayoutLegacy from '../../components/FinancialsLayoutLegacy/FinancialsLayoutLegacy';
import MockFinancialsLayout from '../../../financial/components/MockFinancialsLayout/MockFinancialsLayout';

// financial lib
import parseHistoricalFinancials from '../../../financial/lib/parseHistoricalFinancials.lib.financial';

// financial mocks
import * as financialMockComponents from '../../../financial/mock/components/components.mock';

// layout components
import FullScreenLoader from '../../../layout/components/FullScreenLoader/FullScreenLoader';

// propType
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

// react redux
import {connect} from 'react-redux';

// supplier lib
import getCompanyId from '../../../supplier/lib/getCompanyId.lib.supplier';

class CompanyFinancialsContainer extends Component {
  static propTypes = {
    company: PropTypes.object,
    dispatch: PropTypes.func,
  };

  state = {
    loading: true,
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const {company, dispatch} = this.props;

    if (!!company?.financials || company?.loadedFinancialsPage)
      return this.setState({loading: false});

    try {
      const companyId = getCompanyId(company);
      const companyWithLoadedData = await loadAndAttachAsyncJsonToObjectService(
        {
          company,
          dataObject: {
            extendedPrivateFinancials: loadPublicFinancialsApi(companyId),
            historicalFinancials: loadPrivateFinancialsApi(companyId),
            publicParentCompany: loadParentCompanyApi(companyId),
          },
        }
      );

      const combinedCompany = {
        ...company,
        ...companyWithLoadedData,
        historicalFinancials: !!companyWithLoadedData.historicalFinancials
          ? parseHistoricalFinancials(
              companyWithLoadedData.historicalFinancials
            )
          : null,
        loadedFinancialsPage: true,
      };

      dispatch(
        setGeneralCompanyDataAction({loading: false, company: combinedCompany})
      );
      this.setState({loading: false});
    } catch (error) {
      this.setState({loading: false});
    }
  };

  render() {
    const {company} = this.props;
    const {loading} = this.state;

    const MockComponent =
      financialMockComponents?.[`Financials${company?.CompanyId}`] || null;

    return loading ? (
      <FullScreenLoader />
    ) : MockComponent ? (
      <MockFinancialsLayout>
        {({...props} = {}) => <MockComponent company={company} {...props} />}
      </MockFinancialsLayout>
    ) : !!company.customFinancials ? (
      <CustomFinancialsLayout />
    ) : !!company?.financials ? (
      <FinancialsLayout />
    ) : (
      <FinancialsLayoutLegacy />
    );
  }
}

export default connect((state) => ({company: state.company.company}))(
  CompanyFinancialsContainer
);
